import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { parse } from 'qs';
import ErrorPage from './../common/ErrorPage';
import { getInfoFromURL, setError } from '../../actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TokenData from './../common/TokenData';

export class PageContainer extends Component {
  componentDidMount() {
    if (this.props.errorFlag === null) {
      const query = parse(this.props.match.params.passedInfo);
      if (
        query.r === undefined ||
        query.t === undefined ||
        query.c === undefined ||
        query.r === null ||
        query.t === null ||
        query.c === null ||
        (query && query.t && !new TokenData(query.t).isValid())
      ) {
        this.props.setError(
          'This did not have the correct information provided in the URL.'
        );
      } else {
        this.props.getInfoFromURL(query);
      }
    } else {
      this.props.setError('Tried to access a webpage other than connect-user');
    }
  }

  render() {
    if (this.props.errorFlag) {
      return <ErrorPage />;
    } else {
      return this.props.component;
    }
  }
}

PageContainer.propTypes = {
  match: PropTypes.object,
  component: PropTypes.object
};

const mapStateToProps = state => ({
  errorFlag: state.initial.errorFlag
});

const mapDispatchToProps = dispatch => ({
  getInfoFromURL: queryInfo => dispatch(getInfoFromURL(queryInfo)),
  setError: description => dispatch(setError(description))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PageContainer)
);
